import { makeCrudBuilderInitialState } from "seneca-common/utils/apiStates";
import { subscriptionsCrudStateConfig } from "seneca-common/features/subscriptions/state/consts";

const subscriptionsMetaInitialState = makeCrudBuilderInitialState(
  subscriptionsCrudStateConfig
);

export default subscriptionsMetaInitialState;
